import React from 'react';
import { Label, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const money = (value) => (value == null ? '-' : `$${value}`);

export const MemberUsageCellsV97 = ({ member, virtual }) => {
  const { t } = useTranslation();
  const usage = member.usage_summary;
  return (
    <>
      <Table.Cell className='organization-usage-money-v97'>
        {money(usage?.total_used_usd)}
      </Table.Cell>
      {!virtual && (
        <Table.Cell className='organization-usage-money-v97'>
          {money(usage?.cycle_used_usd)}
          {usage && Number(usage.reserved_usd) > 0 && (
            <small>
              {t('organization.members.reserved')}: {money(usage.reserved_usd)}
            </small>
          )}
        </Table.Cell>
      )}
      <Table.Cell className='organization-usage-money-v97'>
        {!usage
          ? '-'
          : usage.remaining_usd == null
          ? t('organization.unlimited')
          : money(usage.remaining_usd)}
        {usage?.limit_exhausted && (
          <Label basic color='red' size='tiny'>
            {t('organization.members.exhausted')}
          </Label>
        )}
        {usage?.billing_blocked && (
          <Label basic color='grey' size='tiny'>
            {t('organization.members.billing_blocked')}
          </Label>
        )}
      </Table.Cell>
    </>
  );
};

export const MemberUsageSummaryV97 = ({ member, virtual }) => {
  const { t } = useTranslation();
  const usage = member.usage_summary;
  return (
    <dl className='organization-member-usage-v97'>
      <div>
        <dt>{t('organization.members.total_used')}</dt>
        <dd>{money(usage?.total_used_usd)}</dd>
      </div>
      {!virtual && (
        <div>
          <dt>{t('organization.members.cycle_used')}</dt>
          <dd>{money(usage?.cycle_used_usd)}</dd>
        </div>
      )}
      <div>
        <dt>{t('organization.members.available')}</dt>
        <dd>
          {!usage
            ? '-'
            : usage.remaining_usd == null
            ? t('organization.unlimited')
            : money(usage.remaining_usd)}
          {usage?.limit_exhausted && (
            <Label basic color='red' size='tiny'>
              {t('organization.members.exhausted')}
            </Label>
          )}
        </dd>
      </div>
    </dl>
  );
};
